const Mirai = require('./include/_mirai')();
const Media = require('./include/_media')();

require('./include/_smoothscroll');
require('./include/_pagetop');
require('./include/_gnavi');

require('./include/_front-works-carousel');

require('./include/_trunk8');
require('./include/_trunk8_edit');

require('./include/_more-read-btn');
